import React, { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { createPortal } from "react-dom";
import audioPlayerManager from "@audio/AudioPlayerManager/AudioPlayerManager";
import VideoPlayerWrapper from "@video/VideoPlayer";
import { ROUTE_PATHS, VIDEO_PORTAL_ID, radioLiveVideoContainerIds } from "@constants/consts";

const VideoPlayerPortal: React.FC<{
  mainStation: AudioStationEntry;
  inDashboardView: boolean;
}> = ({ mainStation, inDashboardView }) => {
  const {
    query: { slug: stationSlug },
    asPath,
  } = useRouter();

  const videoPortalRef = useRef<HTMLDivElement>(document.createElement("div"));

  const isVideoPlayingOnStationPage =
    asPath.includes(`${ROUTE_PATHS.STATIONS}${stationSlug}`) && stationSlug !== mainStation.slug;

  const containerId =
    inDashboardView && !isVideoPlayingOnStationPage
      ? radioLiveVideoContainerIds.AUDIO_DASHBOARD
      : radioLiveVideoContainerIds.STICKY_PLAYER;

  useEffect(() => {
    const container = document.getElementById(containerId);
    const currentPortal = videoPortalRef.current;
    currentPortal.id = VIDEO_PORTAL_ID;

    if (container) {
      container.appendChild(currentPortal);
    }

    return () => {
      if (container && currentPortal.parentNode === container) {
        container.removeChild(currentPortal);
      }
    };
  }, [containerId]);

  return createPortal(
    <VideoPlayerWrapper
      guid={mainStation.videoGuid || ""}
      onCloseCallback={() => audioPlayerManager.switchVisualStream(false, mainStation)}
    />,
    videoPortalRef.current
  );
};

export default VideoPlayerPortal;
